import { nativeApi } from '@dym/client-bridge';

function getAppToken () {
    return new Promise((resolve, reject) => {
        nativeApi.jsNative.getUserToken({}, (res) => {
            if (res && +res.error === 0) {
                const token = res.data;

                if (token && token.length > 20) { // 登录
                    resolve(token);
                } else {
                    reject();
                }

                return;
            }
            reject();
        });
    });
}

function appLogin() {
    nativeApi.jsNative.showLoginView({
        welcome_id: 57,
        should_reload: true,
        asyncBack: () => {
            window.location.reload();
        }
    });
}

export {
    getAppToken,
    appLogin
};
